<template>
  <v-container>
    <v-toolbar class="mb-4" flat>
      <v-btn to="/costa-pez/administrador/usuarios" text>
        <v-icon left>mdi-chevron-left</v-icon>
        <span>Volver</span>
      </v-btn>
      <v-spacer></v-spacer>
    </v-toolbar>
    <PractitionerProfileCard
      :practitioner="practitioner"
    ></PractitionerProfileCard>
    <v-row>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Contacto</v-card-title>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-phone</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{
                  practitioner.phone
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-email</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{
                  practitioner.email
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col>
        <div>
          <v-card>
            <v-card-title>Acciones</v-card-title>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-1"
                    >Desactivar cuenta</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="practitioner.deleted"
                    @change="updateAccountActive"
                  ></v-switch>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-1"
                    >Dar acceso de administrador</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="practitioner.hasAdminAccess"
                    @change="updateAdminAccess"
                  ></v-switch>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackSuccess.show">
      {{ snackSuccess.message }}
      <sweetalert-icon icon="success" />
    </v-snackbar>

    <v-snackbar v-model="snackError.show">
      {{ snackError.message }}
      <sweetalert-icon icon="error" />
    </v-snackbar>
    <v-snackbar v-model="snackNotFound">
      No se encontró el perfil
      <sweetalert-icon icon="error" />
    </v-snackbar>
  </v-container>
</template>
<script>
import PractitionerForm from "./PractitionerForm.vue";
import PractitionerAvatar from "./PractitionerAvatar";
import PractitionerProfileCard from "./PractitionerProfileCard";
export default {
  components: {
    PractitionerForm,
    PractitionerAvatar,
    PractitionerProfileCard
  },
  data: () => ({
    practitioner: {},
    snackSuccess: {
      message: "",
      show: false
    },
    snackError: {
      message: "",
      show: false
    },
    snackNotFound: false
  }),
  methods: {
    async getData() {
      try {
        let { data: practitioner } = await this.$http.get(
          "practitioner/" + this.$route.params.id
        );
        this.practitioner = practitioner;
      } catch (err) {
        console.log(err);
        switch (err.response.status) {
          case 404:
            this.snackNotFound = true;
            this.$router.push({
              name: "Usuarios"
            });
        }
      }
    },
    async updateAccountActive() {
      try {
        await this.$http.patch("practitioner/" + this.practitioner.id, {
          deleted: this.practitioner.deleted
        });
        this.snackSuccess = {
          show: true,
          message: "Usuario actualizado correctamente"
        };
      } catch (err) {
        this.snackError = {
          show: true,
          message: "Ha ocurrido un error"
        };
      }
    },
    async updateAdminAccess() {
      try {
        await this.$http.patch("practitioner/" + this.practitioner.id, {
          hasAdminAccess: this.practitioner.hasAdminAccess
        });
        this.snackSuccess = {
          show: true,
          message: "Usuario actualizado correctamente"
        };
      } catch (err) {
        this.snackError = {
          show: true,
          message: "Ha ocurrido un error"
        };
      }
    }
  },
  mounted: function() {
    this.getData();
  },
  watch: {
    $route(to, from) {
      if (to.name == "Perfil usuario") {
        this.getData();
      }
      if (from.name == "Perfil usuario") {
        // TODO clean
      }
    }
  }
};
</script>
